// @ts-nocheck
/**
 * PDP Wishlist Counter — Firebase Realtime Database
 * - Firebase (Google) infrastructure = never blocked by ad-blockers
 * - Full CORS support for browser requests
 * - Free forever on Spark plan
 */
(function() {
  'use strict';

  var DB = 'https://karinex-final-default-rtdb.europe-west1.firebasedatabase.app/wishlist';
  var CACHE_TTL = 3 * 60 * 1000; // 3 minutes

  // ── Cache ────────────────────────────────────────────────────────────────
  // Datenschutz (02.10.2026): Zwischenspeicher nur noch im Arbeitsspeicher der
  // Seite, nicht mehr im localStorage der Besucher (§ 25 TDDDG). Alte Eintraege
  // werden einmal entfernt.
  var memo = {};
  (function () {
    try {
      for (var i = localStorage.length - 1; i >= 0; i--) {
        var k = localStorage.key(i);
        if (k && k.indexOf('kx_cnt_') === 0) localStorage.removeItem(k);
      }
    } catch (e) {}
  })();
  function getCached(handle) {
    var o = memo[handle];
    return (o && Date.now() - o.ts < CACHE_TTL) ? o.count : null;
  }

  function setCache(handle, count) {
    memo[handle] = { count: count, ts: Date.now() };
  }

  // ── Wishlist state (per device - integrated with theme wishlist) ────────
  function getWishlistArray() {
    try {
      var data = localStorage.getItem('wishlist');
      return data ? JSON.parse(data) : [];
    } catch(e) { return []; }
  }

  function isWishlisted(h) { 
    return getWishlistArray().indexOf(h) !== -1;
  }

  function setWishlisted(h, v) {
    var arr = getWishlistArray();
    var idx = arr.indexOf(h);
    if (v && idx === -1) arr.push(h);
    else if (!v && idx !== -1) arr.splice(idx, 1);
    
    try { 
      localStorage.setItem('wishlist', JSON.stringify(arr)); 
      window.dispatchEvent(new CustomEvent('wishlist:update', {
        detail: { productHandle: h, isSaved: v }
      }));
      window.dispatchEvent(new Event('wishlist-updated'));
    } catch(e) {}
  }

  // ── UI ───────────────────────────────────────────────────────────────────
  function fmt(n) { return n >= 1000 ? (n/1000).toFixed(1).replace('.0','') + 'K' : String(n); }

  // Minimum count before the number is shown. Set per product page via
  // data-kx-count-min (Theme-Editor setting "Merkliste-Pille ab"). Below it only the
  // heart stays: a "1" is negative social proof. The threshold only
  // suppresses — the displayed number is always the stored one (§ 5 UWG).
  function minCount(el) {
    var host = el && (el.hasAttribute('data-kx-count-min') ? el : el.closest('[data-kx-count-min]'));
    var n = host ? parseInt(host.getAttribute('data-kx-count-min'), 10) : NaN;
    return isNaN(n) || n < 1 ? 1 : n;
  }

  function showCount(wrapper, count) {
    var p = wrapper && wrapper.querySelector('.wishlist-social-proof');
    var c = wrapper && wrapper.querySelector('.wishlist-social-proof__count');
    if (!p || !c) return;
    if (count >= minCount(wrapper)) {
      c.textContent = fmt(count); 
      p.style.display = 'flex'; 
      wrapper.classList.add('has-count');
    }
    else { 
      p.style.display = 'none'; 
      wrapper.classList.remove('has-count');
    }
  }

  // ── Firebase REST API ────────────────────────────────────────────────────
  // Datenschutz (02.10.2026): Verbindung zu Google Firebase nur mit Einwilligung
  // (Schalter "Produkt-Zaehler" in der Kategorie Statistik). Ohne sie bleibt die
  // Merkliste voll nutzbar (nur auf diesem Geraet), Zaehler werden weder
  // geladen noch erhoeht.
  function counterAllowed() {
    try { return !!(window.kxConsent && window.kxConsent.service('analytics.product_counters')); } catch (e) { return false; }
  }

  function fbUrl(handle) {
    return DB + '/' + encodeURIComponent(handle).replace(/%2F/g, '%252F') + '.json';
  }

  function fbRead(handle, cb) {
    if (!counterAllowed()) return;
    fetch(fbUrl(handle))
      .then(function(r) { return r.ok ? r.json() : null; })
      .then(function(d) { cb(d && typeof d.count === 'number' ? d.count : 0); })
      .catch(function() { cb(0); });
  }

  function fbWrite(handle, count, cb) {
    if (!counterAllowed()) return;
    fetch(fbUrl(handle), {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ count: count })
    })
      .then(function(r) { return r.ok ? r.json() : null; })
      .then(function(d) { cb(d && typeof d.count === 'number' ? d.count : count); })
      .catch(function() { cb(count); });
  }

  function increment(handle, cb) {
    fbRead(handle, function(current) {
      var next = current + 1;
      fbWrite(handle, next, function(saved) {
        setCache(handle, saved);
        cb(saved);
      });
    });
  }

  function decrement(handle, cb) {
    fbRead(handle, function(current) {
      var next = Math.max(0, current - 1);
      fbWrite(handle, next, function(saved) {
        setCache(handle, saved);
        cb(saved);
      });
    });
  }

  // ── Init ─────────────────────────────────────────────────────────────────
  var ready = new Set();

  function initButtons() {
    document.querySelectorAll('.wishlist-pdp-btn, .mobile-wishlist-btn, wishlist-heart').forEach(function(btn) {
      var isComponent = btn.tagName.toLowerCase() === 'wishlist-heart';
      var h = btn.dataset.handle || btn.getAttribute('data-product-handle');
      if (!h || ready.has(btn)) return;
      ready.add(btn);

      var wrapper = btn.closest('.wishlist-pdp-wrapper') || btn.parentElement || btn;

      // Desktop: the pill is the WRAPPER (padding, count, label), the click
      // handler sits on the 14x14 button inside it. Measured live 04.09.2026:
      // only the heart core responded, every other point of the 38x28 pill was
      // dead ("das Herz reagiert nicht"). Forward wrapper clicks to the button
      // so the whole pill toggles. The button's own handlers stopPropagation,
      // so a direct heart click never arrives here twice.
      if (!isComponent && wrapper !== btn && wrapper.classList.contains('wishlist-pdp-wrapper')) {
        wrapper.addEventListener('click', function(e) {
          if (btn.contains(e.target)) return;
          e.preventDefault();
          e.stopPropagation();
          btn.click();
        });
      }

      // Restore per-device state for basic buttons
      if (!isComponent && isWishlisted(h)) btn.classList.add('active');

      // Show cached count instantly
      var cached = getCached(h);
      if (cached !== null && cached >= 1) showCount(wrapper, cached);

      // Fetch fresh count from Firebase
      fbRead(h, function(count) {
        setCache(h, count);
        showCount(wrapper, count);
      });

      // Click logic ONLY for basic buttons, wishlist-heart component handles itself
      if (!isComponent) {
        btn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          var adding = !isWishlisted(h);
          if (adding) {
            btn.classList.add('active');
            setWishlisted(h, true); // This emits wishlist:update
          } else {
            btn.classList.remove('active');
            setWishlisted(h, false); // This emits wishlist:update
          }
        });
      }
    });
  }

  // ── One reaction per wishlist:update ──────────────────────────────────
  // Bis 04.09.2026 hingen hier ZWEI Listener am selben Event (einer fuer die
  // Desktop-Wrapper, einer fuer die Pillen). Jeder addierte optimistisch +1
  // auf denselben Cache (sichtbar: 10 -> 12) und jeder rief increment()/
  // decrement() auf — zwei Read-then-Write-Runden gegen Firebase pro Klick,
  // deren Race meist 11, manchmal aber dauerhaft 12 hinterliess. Jetzt:
  // ein optimistischer Wert, alle Oberflaechen, EIN Firebase-Schreibzugriff.
  function paintAll(h, n) {
    document.querySelectorAll('.mobile-wishlist-pill[data-product-handle="'+h+'"]').forEach(function(pill) {
      updatePill(pill, n, h);
    });
    document.querySelectorAll('.wishlist-pdp-btn[data-handle="'+h+'"], .mobile-wishlist-btn[data-handle="'+h+'"], wishlist-heart[data-product-handle="'+h+'"]').forEach(function(btn) {
      var w = btn.closest('.wishlist-pdp-wrapper') || btn.parentElement || btn;
      showCount(w, n);
    });
  }

  window.addEventListener('wishlist:update', function(e) {
    if (!e.detail || !e.detail.productHandle) return;
    if (!counterAllowed()) return;
    var h = e.detail.productHandle;
    var isSaved = e.detail.isSaved;

    // Optimistic: computed ONCE, then painted everywhere
    var opt = isSaved ? (getCached(h) || 0) + 1 : Math.max(0, (getCached(h) || 1) - 1);
    setCache(h, opt);
    paintAll(h, opt);

    // Confirm from Firebase — a single write per click
    var confirm = function(n) { setCache(h, n); paintAll(h, n); };
    if (isSaved) increment(h, confirm);
    else decrement(h, confirm);
  });

  function updatePill(pill, count, h) {
    var countEl = pill.querySelector('.mobile-wishlist-pill__count');
    var enough = count >= minCount(pill);
    if (countEl) {
      if (enough) {
        countEl.textContent = fmt(count);
        countEl.style.display = 'inline-block';
      } else {
        countEl.textContent = '';
        countEl.style.display = 'none';
      }
    }
    // has-count drives the permanent label (::after) in the CSS
    if (enough) pill.classList.add('has-count');
    else pill.classList.remove('has-count');
    if (isWishlisted(h)) pill.classList.add('saved');
    else pill.classList.remove('saved');
  }

  var pillsReady = new Set();

  function initPills() {
    document.querySelectorAll('.mobile-wishlist-pill').forEach(function(pill) {
      var h = pill.getAttribute('data-product-handle');
      if (!h || pillsReady.has(pill)) return;
      pillsReady.add(pill);

      // Saved state
      if (isWishlisted(h)) pill.classList.add('saved');

      // Show cached count instantly
      var cached = getCached(h);
      if (cached !== null) updatePill(pill, cached, h);

      // Fetch fresh count
      fbRead(h, function(count) {
        setCache(h, count);
        updatePill(pill, count, h);
      });

      // Click handler
      pill.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        var adding = !isWishlisted(h);
        setWishlisted(h, adding); // emits wishlist:update
      });
    });
  }


  // Einwilligung erst spaeter erteilt: Zaehler fuer die schon vorhandenen
  // Elemente nachladen (Klick-Handler bestehen bereits).
  function refreshCounts() {
    document.querySelectorAll('.wishlist-pdp-btn, .mobile-wishlist-btn, wishlist-heart').forEach(function(btn) {
      var h = btn.dataset.handle || btn.getAttribute('data-product-handle');
      if (!h) return;
      var wrapper = btn.closest('.wishlist-pdp-wrapper') || btn.parentElement || btn;
      fbRead(h, function(count) { setCache(h, count); showCount(wrapper, count); });
    });
    document.querySelectorAll('.mobile-wishlist-pill').forEach(function(pill) {
      var h = pill.getAttribute('data-product-handle');
      if (!h) return;
      fbRead(h, function(count) { setCache(h, count); updatePill(pill, count, h); });
    });
  }
  if (window.kxConsent && !counterAllowed()) window.kxConsent.onService('analytics.product_counters', refreshCounts);

  initButtons();
  initPills();
  document.addEventListener('DOMContentLoaded', function() { initButtons(); initPills(); });
  window.addEventListener('load', function() { initButtons(); initPills(); });
  setTimeout(function() { initButtons(); initPills(); }, 400);
  setTimeout(function() { initButtons(); initPills(); }, 1500);
  new MutationObserver(function() { initButtons(); initPills(); }).observe(document.documentElement, { childList: true, subtree: true });

})();
